import { ThemeProvider, ThemeDefault } from '@seddi/ui-kit';
import log from 'loglevel';
import ReactDOM from 'react-dom/client';

import { App } from './App';

import './index.css';

// Setup log level.
log.setLevel('info');

const root = ReactDOM.createRoot(document.getElementById('root')!);
root.render(
  <ThemeProvider theme={ThemeDefault}>
    <App />
  </ThemeProvider>,
);
